import * as React from 'react';

interface Props {
  /** Should be a TailwindCSS class starting with `fill-`. */
  fillClass: string;
}

export function ResultsCellDogEar({ fillClass }: Props): React.ReactElement {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10">
      <path fill="#fff" d="M0 0h6a4 4 0 014 4v6H4a4 4 0 01-4-4V0z" />
      <path
        className={`transition ease-in-out duration-150 ${fillClass}`}
        d="M0 0l10 10H4a4 4 0 01-4-4V0z"
      />
    </svg>
  );
}
